/**
* Content Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Content Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'announcement-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      function closeAnnouncementBanner() {
        $( '#announcement-banner' ).slideUp( 0, function() {
          $( ':root' ).css( '--announcementBannerHeight', `0px` );
        } );
      }
      function openAnnouncementBanner() {
        $( '#announcement-banner' ).slideDown( 0, function() {
          $( ':root' ).css( '--announcementBannerHeight', `${announcementBannerHeight}px` );
        } );
        announcementBannerHeight();
      }
      function announcementBannerHeight() {
        if ( $( '#announcement-banner:not([style*="display:none;"])' ).length ) {
          const announcementBannerHeight = $( '#announcement-banner' ).outerHeight();
          $( ':root' ).css( '--announcementBannerHeight', `${announcementBannerHeight}px` );
        }
      }

      announcementBannerHeight();
      window.addEventListener( 'resize', function() {
        announcementBannerHeight();
      } );

      if ( !sessionStorage.getItem( 'performanceparts-ab-seen' ) ) {
        sessionStorage.setItem( 'performanceparts-ab-seen', 'false' );
      }
      if ( sessionStorage.getItem( 'performanceparts-ab-seen' ) === 'false' ) {
        openAnnouncementBanner();
      }

      $( '#announcement-banner__close' ).on( 'click', function() {
        closeAnnouncementBanner();
        sessionStorage.setItem( 'performanceparts-ab-seen', 'true' );
      } );
    },
    finalize: function() {

    },
  };

  // Hooks the component into the app
  app.registerComponent( 'announcement-banner', COMPONENT );
} )( app );
